export const globalPaperBackgroundColor = "#f5fff7";

export const globalBackgroundColor = "#c5d3c9";

export const interactiveCalculatorInputBoxColor = "#f7fdf9";

export const globalInputField = "white";

export const settingsInInteractiveCalculator = "#c2f0d1";

export const settingsAccordionDetails = "#def7e6";
